import { createApp } from 'vue'
import App from './App.vue'


let app = createApp(App)

app.mount('#app')